import { render, staticRenderFns } from "./ImportLogs.vue?vue&type=template&id=32244a9b"
import script from "./ImportLogs.vue?vue&type=script&lang=js"
export * from "./ImportLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports